/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktResponseBaseRights
 */
export interface GetAktResponseBaseRights {
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseBaseRights
     */
    edit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseBaseRights
     */
    dispo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetAktResponseBaseRights
     */
    _delete?: boolean;
}

export function GetAktResponseBaseRightsFromJSON(json: any): GetAktResponseBaseRights {
    return GetAktResponseBaseRightsFromJSONTyped(json, false);
}

export function GetAktResponseBaseRightsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseBaseRights {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'edit': !exists(json, 'edit') ? undefined : json['edit'],
        'dispo': !exists(json, 'dispo') ? undefined : json['dispo'],
        '_delete': !exists(json, 'delete') ? undefined : json['delete'],
    };
}

export function GetAktResponseBaseRightsToJSON(value?: GetAktResponseBaseRights | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edit': value.edit,
        'dispo': value.dispo,
        'delete': value._delete,
    };
}


